.root svg {
  margin: 0 !important;
  margin-left: 4px !important;
}

.listItem * {
  cursor: pointer;
}

.endAdornment {
  top: unset;
  bottom: 8px;
}
